//import colors from '../constants/colors';
//import colors from '../constants/colors-set1';
import colors from '../constants/colorsSet';
import store from '../store/index';
//import distinctColors from 'distinct-colors';

export default {
    findColorRange(growth) {
        let foundRange = null;

        Object.keys(colors).forEach((colorRange) => {
            const colorMin = colorRange.split('_')[0];
            const colorMax = colorRange.split('_')[1];

            if ((!colorMin || growth > parseInt(colorMin, 10)) && (!colorMax || growth < parseInt(colorMax, 10))) {
                foundRange = colorRange;
            }
        });

        return foundRange;
    },
    getLineInfo(data, dataKey, chartType) {
        const revenues = data[dataKey];

        if (!revenues || revenues.length === 0) {
            return {
                growth: 0,
                range: chartType === 'growth' ? this.getGrowthRateColorRange(dataKey) : Object.keys(colors)[0],
            };
        }

        const firstRevenue = parseFloat(revenues[0].revenue);
        const totalRevenue = revenues.reduce((total, current) => total + parseFloat(current.revenue), 0);
        const averageRevenue = totalRevenue / revenues.length;
        const growth = ((averageRevenue / firstRevenue) - 1) * 100;

        return {
            growth,
            range: this.findColorRange(growth),
        };
    },
    getGrowthRateColorRange(dataKey) {
        switch (dataKey) {
        case '30_':
            return colors['55_'][1];
        case '10_30':
            return colors['35_55'][5];
        case '-10_10':
            return colors['-15_15'][5];
        case '-30_-10':
            return colors['-55_-35'][3];
        case '_-30':
            return colors['_-55'][0];
        default:
            return colors['55_'][1];
        }
    },
    getDataRanges(data, chartType) {
        const dataRanges = Object.keys(colors).reduce((total, colorKey) => ({ ...total, [colorKey]: {} }), {});

        Object.keys(data).forEach((dataKey) => {
            const lineInfo = this.getLineInfo(data, dataKey, chartType);
            dataRanges[lineInfo.range][dataKey] = lineInfo.growth;
        });

        return dataRanges;
    },
    sortDataKeys(rangeData) {
        return Object.keys(rangeData).sort((a, b) => {
            const growthA = Math.abs(parseInt(rangeData[a], 10));
            const growthB = Math.abs(parseInt(rangeData[b], 10));

            return growthB - growthA;
        });
    },
    getAllLinesColors(data, chartType) {
        //TODO: Clean the commented methods
        
        //const dataRanges = this.getDataRanges(data, chartType);
        const dataColors = {};
        let allColors = [];
        //const clrs = distinctColors({count:80});
        const dataRangesAllLength = Object.keys(data).length;

        Object.keys(colors).forEach(index => allColors = allColors.concat(colors[index]));

        // exclude FIC & BIC & FIC/BIC colors
        const { fic_color, bic_color, fic_bic_color} = store.getters["setting/getAll"];
        allColors = allColors.filter((color) => color != fic_color && color != bic_color && color != fic_bic_color );


        // Object.keys(dataRanges).forEach((dataRangeKey) => {
        //     dataRangesAllLength += Object.keys(dataRanges[dataRangeKey]).length;
        // });

        //const colorLength = clrs.length;
        const colorLength = allColors.length;
        //const step = colorLength / dataRangesAllLength < 1 ? 1 : colorLength / dataRangesAllLength;
        let currentColorIndex = 0;

        Object.keys(data).forEach((dataKey) => {
                dataColors[dataKey] = allColors[currentColorIndex];
                //currentColorIndex = (currentColorIndex + step -0.15) % colorLength;            
                currentColorIndex++;            
        });
        /*
        Object.keys(dataRanges).forEach((dataRangeKey) => {
            const sortedDataKeys = this.sortDataKeys(dataRanges[dataRangeKey]);

            sortedDataKeys.forEach((dataKey) => {
                dataColors[dataKey] = allColors[currentColorIndex];
                currentColorIndex = (currentColorIndex + step) % colorLength;
            });
        });
*/
        return dataColors;
    },
};